import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit1-conclusion',
  templateUrl: './unit1-conclusion.component.html',
  styleUrls: ['./unit1-conclusion.component.css']
})
export class Unit1ConclusionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
